import Vue from 'vue'

const ErrorModal = Vue.component('error-modal', {
    props: ['message'],
    template: '#error_modal',
    methods: {
    	close: function() {
            this.$ebus.$emit("msg:clear");
    		this.$ebus.$emit("modal:close");
    	}
    }
})

export default ErrorModal;
